import DateTools from 'utils/dates/dateTools'

const getUsefulData = data => {
  const usefulData = data.items
    .sort((itemA, itemB) => {
      return itemA.date > itemB.date ? -1 : 1
    })
    .map(item => ({
      year: DateTools.getYearFromDateString(item.date),
      description: item.description,
      title: item.title,
      url: item.url
    }))
  return usefulData
}

const relatedDocumentsBodyAdapter = {
  getUsefulData
}

export default relatedDocumentsBodyAdapter



// WEBPACK FOOTER //
// ./src/modules/RelatedDocuments/RelatedDocumentsBody/RelatedDocumentsBodyAdapter.js